const program_commitee_list = {
    "Research Track Senior Program Committee": [
        {
            "name": "Maribel Acosta",
            "institution": "Technical University of Munich",
            "country": "Germany"
        },
        {
            "name": "Carlos Buil Aranda",
            "institution": "Philip Morris International",
            "country": "Spain"
        },
        {
            "name": "David Chaves-Fraga",
            "institution": "Universidade de Santiago de Compostela",
            "country": "Spain"
        },
        {
            "name": "Gong Cheng",
            "institution": "Nanjing University",
            "country": "China"
        },
        {
            "name": "Michael Cochez",
            "institution": "Vrije Universiteit Amsterdam",
            "country": "Netherlands"
        },
        {
            "name": "Oscar Corcho",
            "institution": "Universidad Polit‘ecnica de Madrid",
            "country": "Spain"
        },
        {
            "name": "Julien Corman",
            "institution": "Free University of Bozen-Bolzano",
            "country": "Italy"
        },
        {
            "name": "Gianluca Demartini",
            "institution": "The University of Queensland",
            "country": "Australia"
        },
        {
            "name": "Anastasia Dimou",
            "institution": "KU Leuven",
            "country": "Belgium"
        },
        {
            "name": "Mauro Dragoni",
            "institution": "Fondazione Bruno Kessler",
            "country": "Italy"
        },
        {
            "name": "Peter Haase",
            "institution": "metaphacts",
            "country": "Germany"
        },
        {
            "name": "Olaf Hartig",
            "institution": "Link¨oping University",
            "country": "Sweden"
        },
        {
            "name": "Aidan Hogan",
            "institution": "Universidad de Chile",
            "country": "Chile"
        },
        {
            "name": "Laura Hollink",
            "institution": "Centrum Wiskunde & Informatica",
            "country": "Netherlands"
        },
        {
            "name": "Ernesto Jim´enez-Ruiz",
            "institution": "City St George’s, University of London",
            "country": "UK"
        },
        {
            "name": "Boris Motik",
            "institution": "University of Oxford",
            "country": "UK"
        },
        {
            "name": "Terry Payne",
            "institution": "University of Liverpool",
            "country": "UK"
        },
        {
            "name": "Catia Pesquita",
            "institution": "Universidade de Lisboa",
            "country": "Portugal"
        },
        {
            "name": "Mar´ıa Poveda-Villal´on",
            "institution": "Universidad Polit´ecnica de Madrid",
            "country": "Spain"
        },
        {
            "name": "Anisa Rula",
            "institution": "University of Brescia",
            "country": "Italy"
        },
        {
            "name": "Hala Skaf-Molli",
            "institution": "University of Nantes - LS2N",
            "country": "France"
        },
        {
            "name": "Kavitha Srinivas",
            "institution": "IBM Research",
            "country": "USA"
        },
        {
            "name": "Kostas Stefanidis",
            "institution": "Tampere University",
            "country": "Finland"
        },
        {
            "name": "Valentina Tamma",
            "institution": "University of Liverpool",
            "country": "UK"
        },
        {
            "name": "Maria-Esther Vidal",
            "institution": "Leibniz University Hannover",
            "country": "Germany"
        },
        {
            "name": "Domagoj Vrgoc",
            "institution": "Pontificia Universidad Cat´olica de Chile",
            "country": "Chile"
        }
    ],
    "Research Track Program Committee": [
        {
            "name": "Nathalie Abadie",
            "institution": "LASTIG, Univ. Gustave Eiffel, IGN-ENSG",
            "country": "France"
        },
        {
            "name": "Alessandro Adamou",
            "institution": "Bibliotheca Hertziana - Max Planck Insitute for Art History",
            "country": "Italy"
        },
        {
            "name": "Shqiponja Ahmetaj",
            "institution": "TU Wien",
            "country": "Austria"
        },
        {
            "name": "Mehwish Alam",
            "institution": "Telecom Paris",
            "country": "France"
        },
        {
            "name": "Elvira Amador-Domínguez",
            "institution": "Universidad Politécnica de Madrid",
            "country": "Spain"
        },
        {
            "name": "Amin Anjomshoaa",
            "institution": "Vienna University of Economics and Business",
            "country": "Austria"
        },
        {
            "name": "Gianluca Apriceno",
            "institution": "Fondazione Bruno Kessler",
            "country": "Italy"
        },
        {
            "name": "Julián Arenas-Guerrero",
            "institution": "Universidad Politécnica de Madrid",
            "country": "Spain"
        },
        {
            "name": "Dörthe Arndt",
            "institution": "TU Dresden",
            "country": "Germany"
        },
        {
            "name": "Carlos Badenes-Olmedo",
            "institution": "Universidad Politécnica de Madrid",
            "country": "Spain"
        },
        {
            "name": "Tania Bailoni",
            "institution": "Fondazione Bruno Kessler",
            "country": "Italy"
        },
        {
            "name": "Pierpaolo Basile",
            "institution": "University of Bari",
            "country": "Italy"
        },
        {
            "name": "Christian Bizer",
            "institution": "University of Mannheim",
            "country": "Germany"
        },
        {
            "name": "Eva Blomqvist",
            "institution": "Linköping University",
            "country": "Sweden"
        },
        {
            "name": "Carlos Bobed",
            "institution": "University of Zaragoza",
            "country": "Spain"
        },
        {
            "name": "Piero Bonatti",
            "institution": "University of Naples Federico II",
            "country": "Italy"
        },
        {
            "name": "Pieter Bonte",
            "institution": "KU Leuven",
            "country": "Belgium"
        },
        {
            "name": "Paolo Bouquet",
            "institution": "University of Trento",
            "country": "Italy"
        },
        {
            "name": "Janez Brank",
            "institution": "Jožef Stefan Institute",
            "country": "Slovenia"
        },
        {
            "name": "Davide Buscaldi",
            "institution": "LIPN, Université Paris 13, Sorbonne Paris Cité",
            "country": "France"
        },
        {
            "name": "Jean-Paul Calbimonte",
            "institution": "University of Applied Sciences and Arts Western Switzerland HES-SO",
            "country": "Switzerland"
        },
        {
            "name": "Pablo Calleja",
            "institution": "Universidad Politécnica de Madrid",
            "country": "Spain"
        },
        {
            "name": "Cinzia Cappiello",
            "institution": "Politecnico di Milano",
            "country": "Italy"
        },
        {
            "name": "Antonella Carbonaro",
            "institution": "University of Bologna",
            "country": "Italy"
        },
        {
            "name": "Davide Ceolin",
            "institution": "Centrum Wiskunde & Informatica",
            "country": "Netherlands"
        },
        {
            "name": "Pierre-Antoine Champin",
            "institution": "W3C / Inria",
            "country": "France"
        },
        {
            "name": "Nathalie Charbel",
            "institution": "Neo4j",
            "country": "France"
        },
        {
            "name": "Victor Charpenay",
            "institution": "Mines Saint-Etienne",
            "country": "France"
        },
        {
            "name": "Vinay Chaudhri",
            "institution": "Knowledge Systems Research LLC",
            "country": "USA"
        },
        {
            "name": "Jiaoyan Chen",
            "institution": "The University of Manchester",
            "country": "UK"
        },
        {
            "name": "Ioannis Chrysakis",
            "institution": "Netcompany, Research and Innovation Development Department, Luxemburg, and Ghent University & KU Leuven",
            "country": "Belgium"
        },
        {
            "name": "Yashrajsinh Chudasama",
            "institution": "Leibniz University Hannover",
            "country": "Germany"
        },
        {
            "name": "Philipp Cimiano",
            "institution": "Bielefeld University",
            "country": "Germany"
        },
        {
            "name": "Andrei Ciortea",
            "institution": "University of St.Gallen",
            "country": "Switzerland"
        },
        {
            "name": "Pieter Colpaert",
            "institution": "Ghent University – imec",
            "country": "Belgium"
        },
        {
            "name": "Philippe Cudre-Mauroux",
            "institution": "University of Fribourg",
            "country": "Switzerland"
        },
        {
            "name": "Claudia d’Amato",
            "institution": "University of Bari",
            "country": "Italy"
        },
        {
            "name": "Mathieu D’Aquin",
            "institution": "LORIA, University of Lorraine",
            "country": "France"
        },
        {
            "name": "Enrico Daga",
            "institution": "The Open University",
            "country": "UK"
        },
        {
            "name": "Ioannis Dasoulas",
            "institution": "KU Leuven",
            "country": "Belgium"
        },
        {
            "name": "Victor de Boer",
            "institution": "Vrije Universiteit Amsterdam",
            "country": "Netherlands"
        },
        {
            "name": "Stefano De Giorgis",
            "institution": "Vrije Universiteit Amsterdam",
            "country": "Netherlands"
        },
        {
            "name": "Christophe Debruyne",
            "institution": "Université de Liège",
            "country": "Belgium"
        },
        {
            "name": "Daniele Dell’Aglio",
            "institution": "Aalborg University",
            "country": "Denmark"
        },
        {
            "name": "Elena Demidova",
            "institution": "University of Bonn",
            "country": "Germany"
        },
        {
            "name": "Stefan Dietze",
            "institution": "GESIS & Heinrich-Heine-University Düsseldorf",
            "country": "Germany"
        },
        {
            "name": "John Domingue",
            "institution": "The Open University",
            "country": "UK"
        },
        {
            "name": "Fajar J. Ekaputra",
            "institution": "Vienna University of Economics and Business",
            "country": "Austria"
        },
        {
            "name": "Basil Ell",
            "institution": "CITEC, Universität Bielefeld and Norwegian Centre for Knowledge-driven Machine Learning, University of Oslo",
            "country": "Norway"
        },
        {
            "name": "Lorena Etcheverry",
            "institution": "Universidad de la República",
            "country": "Uruguay"
        },
        {
            "name": "David Eyers",
            "institution": "University of Otago",
            "country": "New Zealand"
        },
        {
            "name": "Daniel Faria",
            "institution": "INESC-ID, Instituto Superior Técnico, Universidade de Lisboa",
            "country": "Portugal"
        },
        {
            "name": "Catherine Faron",
            "institution": "Université Côte d’Azur",
            "country": "France"
        },
        {
            "name": "Anna Fensel",
            "institution": "Wageningen University and Research",
            "country": "Netherlands"
        },
        {
            "name": "Holly Ferguson",
            "institution": null,
            "country": "USA"
        },
        {
            "name": "Javier D. Fernández",
            "institution": "F. Hoffmann-La Roche AG",
            "country": "Switzerland"
        },
        {
            "name": "Sebastián Ferrada",
            "institution": "Universidad de Chile",
            "country": "Chile"
        },
        {
            "name": "Erwin Filtz",
            "institution": "Siemens AG Osterreich",
            "country": "Austria"
        },
        {
            "name": "Giorgos Flouris",
            "institution": "ICS-FORTH",
            "country": "Greece"
        },
        {
            "name": "Ken Fukuda",
            "institution": "National Institute of Advanced Industrial Science and Technology (AIST)",
            "country": "Japan"
        },
        {
            "name": "Naoki Fukuta",
            "institution": "Shizuoka University",
            "country": "Japan"
        },
        {
            "name": "Irini Fundulaki",
            "institution": "ICS-FORTH",
            "country": "Greece"
        },
        {
            "name": "Mohamed H. Gad-Elrab",
            "institution": "Bosch AI",
            "country": "Germany"
        },
        {
            "name": "Luis Galárraga",
            "institution": "Inria",
            "country": "France"
        },
        {
            "name": "Fabien Gandon",
            "institution": "Inria",
            "country": "France"
        },
        {
            "name": "Aldo Gangemi",
            "institution": "Università di Bologna & CNR-ISTC",
            "country": "Italy"
        },
        {
            "name": "Sandra Geisler",
            "institution": "RWTH Aachen University",
            "country": "Germany"
        },
        {
            "name": "Stefano Germano",
            "institution": "University of Oxford",
            "country": "UK"
        },
        {
            "name": "Pouya Ghiasnezhad Omran",
            "institution": "Australian National University",
            "country": "Australia"
        },
        {
            "name": "Martin Giese",
            "institution": "University of Oslo",
            "country": "Norway"
        },
        {
            "name": "Rafael Gonçalves",
            "institution": "Stanford University",
            "country": "USA"
        },
        {
            "name": "Simon Gottschalk",
            "institution": "Leibniz Universität Hannover, L3S Research Center",
            "country": "Germany"
        },
        {
            "name": "Guido Governatori",
            "institution": "Central Queensland University",
            "country": "Australia"
        },
        {
            "name": "Jorge Gracia",
            "institution": "University of Zaragoza",
            "country": "Spain"
        },
        {
            "name": "Paul Groth",
            "institution": "University of Amsterdam",
            "country": "Netherlands"
        },
        {
            "name": "Tudor Groza",
            "institution": "Bioinformatics Institute, A*STAR",
            "country": "Singapore"
        },
        {
            "name": "Claudio Gutierrez",
            "institution": "Universidad de Chile",
            "country": "Chile"
        },
        {
            "name": "José Manuel Gómez Pérez",
            "institution": "expert.ai",
            "country": "Spain"
        },
        {
            "name": "Andreas Harth",
            "institution": "Friedrich-Alexander-Universität Erlangen-Nürnberg and Fraunhofer IIS",
            "country": "Germany"
        },
        {
            "name": "Mounira Harzallah",
            "institution": "LS2N, University of Nantes",
            "country": "France"
        },
        {
            "name": "Oktie Hassanzadeh",
            "institution": "IBM Research",
            "country": "USA"
        },
        {
            "name": "Maria M. Hedblom",
            "institution": "Jönköping University",
            "country": "Sweden"
        },
        {
            "name": "Daniel Hernández",
            "institution": "University of Stuttgart",
            "country": "Germany"
        },
        {
            "name": "Sven Hertling",
            "institution": "University of Mannheim",
            "country": "Germany"
        },
        {
            "name": "Ryohei Hisano",
            "institution": "The University of Tokyo",
            "country": "Japan"
        },
        {
            "name": "Andreas Hotho",
            "institution": "University of Wuerzburg",
            "country": "Germany"
        },
        {
            "name": "Wei Hu",
            "institution": "Nanjing University",
            "country": "China"
        },
        {
            "name": "Luis Ibanez-Gonzalez",
            "institution": "University of Southampton",
            "country": "UK"
        },
        {
            "name": "Ryutaro Ichise",
            "institution": "Institute of Science Tokyo",
            "country": "Japan"
        },
        {
            "name": "Enrique Iglesias",
            "institution": "Forschungszentrum L3S",
            "country": "Germany"
        },
        {
            "name": "Ana Iglesias-Molina",
            "institution": "Universidad Politécnica de Madrid",
            "country": "Spain"
        },
        {
            "name": "Prateek Jain",
            "institution": "The Trade Desk, Inc.",
            "country": "USA"
        },
        {
            "name": "Jan-Christoph Kalo",
            "institution": "University of Amsterdam",
            "country": "Netherlands"
        },
        {
            "name": "Timotheus Kampik",
            "institution": "SAP, Umeå University",
            "country": "Sweden"
        },
        {
            "name": "Takahiro Kawamura",
            "institution": "The University of Tokyo",
            "country": "Japan"
        },
        {
            "name": "Mayank Kejriwal",
            "institution": "University of Southern California",
            "country": "USA"
        },
        {
            "name": "Ilkcan Keles",
            "institution": "Booking.com",
            "country": "Netherlands"
        },
        {
            "name": "Elmar Kiesling",
            "institution": "Vienna University of Economics and Business",
            "country": "Austria"
        },
        {
            "name": "Haridimos Kondylakis",
            "institution": "Institute of Computer Science, FORTH",
            "country": "Greece"
        },
        {
            "name": "George Konstantinidis",
            "institution": "University of Southampton",
            "country": "UK"
        },
        {
            "name": "Roman Kontchakov",
            "institution": "Birkbeck University of London",
            "country": "UK"
        },
        {
            "name": "Manolis Koubarakis",
            "institution": "National and Kapodistrian University of Athens",
            "country": "Greece"
        },
        {
            "name": "Markus Krötzsch",
            "institution": "TU Dresden",
            "country": "Germany"
        },
        {
            "name": "Tobias Käfer",
            "institution": "Karlsruhe Institute of Technology",
            "country": "Germany"
        },
        {
            "name": "Jose Emilio Labra Gayo",
            "institution": "Universidad de Oviedo",
            "country": "Spain"
        },
        {
            "name": "Christoph Lange",
            "institution": "Fraunhofer Institute for Applied Information Technology FIT and RWTH Aachen University",
            "country": "Germany"
        },
        {
            "name": "Davide Lanti",
            "institution": "Free University of Bozen-Bolzano",
            "country": "Italy"
        },
        {
            "name": "Danh Le Phuoc",
            "institution": "TU Berlin",
            "country": "Germany"
        },
        {
            "name": "Maxime Lefrançois",
            "institution": "MINES Saint-Etienne",
            "country": "France"
        },
        {
            "name": "Huanyu Li",
            "institution": "Linköping University",
            "country": "Sweden"
        },
        {
            "name": "Ke Liang",
            "institution": "National University of Defense Technology",
            "country": "China"
        },
        {
            "name": "Pasquale Lisena",
            "institution": "EURECOM",
            "country": "France"
        },
        {
            "name": "Vanessa Lopez",
            "institution": "IBM Research Europe",
            "country": "Ireland"
        },
        {
            "name": "Maria Maleshkova",
            "institution": "Helmut Schmidt University",
            "country": "Germany"
        },
        {
            "name": "Lorenzo Marconi",
            "institution": "Sapienza University of Rome",
            "country": "Italy"
        },
        {
            "name": "Milan Markovic",
            "institution": "University of Aberdeen",
            "country": "UK"
        },
        {
            "name": "Jose L. Martinez-Rodriguez",
            "institution": "Autonomous University of Tamaulipas",
            "country": "Mexico"
        },
        {
            "name": "Simon Mayer",
            "institution": "University of St.Gallen",
            "country": "Switzerland"
        },
        {
            "name": "Hande McGinty",
            "institution": "Kansas State University, Manhattan KS",
            "country": "USA"
        },
        {
            "name": "Albert Meroño-Peñuela",
            "institution": "King’s College London",
            "country": "UK"
        },
        {
            "name": "Nandana Mihindukulasooriya",
            "institution": "IBM Research AI",
            "country": "USA"
        },
        {
            "name": "Pascal Molli",
            "institution": "University of Nantes - LS2N",
            "country": "France"
        },
        {
            "name": "Deshendran Moodley",
            "institution": "University of Cape Town",
            "country": "South Africa"
        },
        {
            "name": "Summaya Mumtaz",
            "institution": "Merkle Inc",
            "country": "USA"
        },
        {
            "name": "Raghava Mutharaju",
            "institution": "IIIT-Delhi",
            "country": "India"
        },
        {
            "name": "Hubert Naacke",
            "institution": "Sorbonne Université, LIP6",
            "country": "France"
        },
        {
            "name": "María Navas-Loro",
            "institution": "Universidad Politécnica de Madrid",
            "country": "Spain"
        },
        {
            "name": "Sebastian Neumaier",
            "institution": "St. Pölten University of Applied Sciences",
            "country": "Austria"
        },
        {
            "name": "Axel-Cyrille Ngonga Ngomo",
            "institution": "Paderborn University",
            "country": "Germany"
        },
        {
            "name": "Andriy Nikolov",
            "institution": "AstraZeneca",
            "country": "UK"
        },
        {
            "name": "Werner Nutt",
            "institution": "Free University of Bozen-Bolzano",
            "country": "Italy"
        },
        {
            "name": "Andrea Giovanni Nuzzolese",
            "institution": "CNR - Institute of Cognitive Sciences and Technologies",
            "country": "Italy"
        },
        {
            "name": "Femke Ongenae",
            "institution": "Ghent University - imec",
            "country": "Belgium"
        },
        {
            "name": "Francesco Osborne",
            "institution": "The Open University",
            "country": "UK"
        },
        {
            "name": "Julian Padget",
            "institution": "University of Bath",
            "country": "UK"
        },
        {
            "name": "Matteo Palmonari",
            "institution": "University of Milano-Bicocca",
            "country": "Italy"
        },
        {
            "name": "Jeff Pan",
            "institution": "University of Edinburgh",
            "country": "UK"
        },
        {
            "name": "Peter Patel-Schneider",
            "institution": "",
            "country": "USA/Canada"
        },
        {
            "name": "Evan Patton",
            "institution": "Massachusetts Institute of Technology",
            "country": "USA"
        },
        {
            "name": "Heiko Paulheim",
            "institution": "University of Mannheim",
            "country": "Germany"
        },
        {
            "name": "Bernardo Pereira Nunes",
            "institution": "Australian National University",
            "country": "Australia"
        },
        {
            "name": "Romana Pernisch",
            "institution": "Vrije Universiteit Amsterdam",
            "country": "Netherlands"
        },
        {
            "name": "Alina Petrova",
            "institution": "Thomson Reuters Labs",
            "country": "UK"
        },
        {
            "name": "Rafael Peñaloza",
            "institution": "University of Milano-Bicocca",
            "country": "Italy"
        },
        {
            "name": "Giuseppe Pirro",
            "institution": "Unical",
            "country": "Italy"
        },
        {
            "name": "Dimitris Plexousakis",
            "institution": "Institute of Computer Science, FORTH",
            "country": "Greece"
        },
        {
            "name": "Axel Polleres",
            "institution": "Vienna University of Economics and Business - WU Wien",
            "country": "Austria"
        },
        {
            "name": "Nico Potyka",
            "institution": "Cardiff University",
            "country": "UK"
        },
        {
            "name": "Nicoleta Preda",
            "institution": "University de Versailles",
            "country": "France"
        },
        {
            "name": "Cédric Pruski",
            "institution": "Luxembourg Institute of Science and Technology",
            "country": "Luxembourg"
        },
        {
            "name": "Disha Purohit",
            "institution": "TIB – Leibniz Information Centre for Science and Technology and University Library in Hanover",
            "country": "Germany"
        },
        {
            "name": "Hemant Purohit",
            "institution": "George Mason University",
            "country": "USA"
        },
        {
            "name": "Umair Qudus",
            "institution": "University of Paderborn",
            "country": "Germany"
        },
        {
            "name": "Joe Raad",
            "institution": "University of Paris-Saclay",
            "country": "France"
        },
        {
            "name": "David Ratcliffe",
            "institution": "Microsoft",
            "country": "Australia"
        },
        {
            "name": "Juan L. Reutter",
            "institution": "Pontificia Universidad Católica",
            "country": "Chile"
        },
        {
            "name": "Martin Rezk",
            "institution": "Google",
            "country": "USA"
        },
        {
            "name": "Mariano Rico",
            "institution": "Universidad Politécnica de Madrid",
            "country": "Spain"
        },
        {
            "name": "Philipp D. Rohde",
            "institution": "TIB Leibniz Information Centre for Science and Technology",
            "country": "Germany"
        },
        {
            "name": "Edelweis Rohrer",
            "institution": "Universidad de la República",
            "country": "Uruguay"
        },
        {
            "name": "Julián Rojas",
            "institution": "Ghent University",
            "country": "Belgium"
        },
        {
            "name": "Oscar Romero",
            "institution": "Universitat Politècnica de Catalunya",
            "country": "Spain"
        },
        {
            "name": "Marco Rospocher",
            "institution": "Università degli Studi di Verona",
            "country": "Italy"
        },
        {
            "name": "Jože M. Rožanec",
            "institution": "Jožef Stefan Institute",
            "country": "Slovenia"
        },
        {
            "name": "Marta Sabou",
            "institution": "Vienna University of Economics and Business",
            "country": "Austria"
        },
        {
            "name": "Harald Sack",
            "institution": "FIZ Karlsruhe, Leibniz Institute for Information Infrastructure & KIT Karlsruhe",
            "country": "Germany"
        },
        {
            "name": "Tomer Sagi",
            "institution": "Aalborg Universitet",
            "country": "Denmark"
        },
        {
            "name": "Muhammad Saleem",
            "institution": "DICE, University Of Paderborn",
            "country": "Germany"
        },
        {
            "name": "Emanuel Sallinger",
            "institution": "TU Wien",
            "country": "Austria"
        },
        {
            "name": "Bruno Sartini",
            "institution": "Ludwig-Maximilians-Universität München",
            "country": "Germany"
        },
        {
            "name": "Marco Luca Sbodio",
            "institution": "IBM Research",
            "country": "Ireland"
        },
        {
            "name": "Francois Scharffe",
            "institution": "University of Montpellier",
            "country": "France"
        },
        {
            "name": "Ralf Schenkel",
            "institution": "Trier University",
            "country": "Germany"
        },
        {
            "name": "Daniel Schwabe",
            "institution": "BioBD Lab, Dept. of Informatics, PUC-Rio",
            "country": "Brazil"
        },
        {
            "name": "Juan Sequeda",
            "institution": "ServiceNow",
            "country": "USA"
        },
        {
            "name": "Patricia Serrano Alvarado",
            "institution": "University of Nantes - LS2N",
            "country": "France"
        },
        {
            "name": "Kuldeep Singh",
            "institution": "Cerence GmbH and Zerotha Research",
            "country": "Germany"
        },
        {
            "name": "Martin G Skjæveland",
            "institution": "University of Oslo",
            "country": "Norway"
        },
        {
            "name": "Sebastian Skritek",
            "institution": "TU Wien",
            "country": "Austria"
        },
        {
            "name": "Blerina Spahiu",
            "institution": "Università degli Studi di Milano Bicocca",
            "country": "Italy"
        },
        {
            "name": "Steffen Staab",
            "institution": "UNI Stuttgart",
            "country": "Germany"
        },
        {
            "name": "Nadine Steinmetz",
            "institution": "University of Applied Sciences Erfurt",
            "country": "Germany"
        },
        {
            "name": "Lise Stork",
            "institution": "University of Amsterdam",
            "country": "Netherlands"
        },
        {
            "name": "Chang Sun",
            "institution": "Institute of Data Science, Maastricht University",
            "country": "Netherlands"
        },
        {
            "name": "Vojtěch Svátek",
            "institution": "Prague University of Economics and Business",
            "country": "Czechia"
        },
        {
            "name": "Danai Symeonidou",
            "institution": "INRAE",
            "country": "France"
        },
        {
            "name": "Ruben Taelman",
            "institution": "Ghent University – imec",
            "country": "Belgium"
        },
        {
            "name": "Lionel Tailhardat",
            "institution": "Orange",
            "country": "France"
        },
        {
            "name": "Hideaki Takeda",
            "institution": "National Institute of Informatics",
            "country": "Japan"
        },
        {
            "name": "Aisling Third",
            "institution": "The Open University",
            "country": "UK"
        },
        {
            "name": "Steffen Thoma",
            "institution": "FZI Research Center for Information Technology",
            "country": "Germany"
        },
        {
            "name": "Ilaria Tiddi",
            "institution": "Vrije Universiteit Amsterdam",
            "country": "Netherlands"
        },
        {
            "name": "Dominik Tomaszuk",
            "institution": "University of Bialystok",
            "country": "Poland"
        },
        {
            "name": "Riccardo Tommasini",
            "institution": "INSA Lyon - LIRIS",
            "country": "France"
        },
        {
            "name": "Cassia Trojahn",
            "institution": "Université Grenoble Alpes, INRIA",
            "country": "France"
        },
        {
            "name": "Raphaël Troncy",
            "institution": "EURECOM",
            "country": "France"
        },
        {
            "name": "Takanori Ugai",
            "institution": "Fujitsu Limited",
            "country": "Japan"
        },
        {
            "name": "Ricardo Usbeck",
            "institution": "Leuphana University Lüneburg",
            "country": "Germany"
        },
        {
            "name": "Marieke van Erp",
            "institution": "KNAW Humanities Cluster",
            "country": "Netherlands"
        },
        {
            "name": "Ruben Verborgh",
            "institution": "Ghent University – imec",
            "country": "Belgium"
        },
        {
            "name": "Serena Villata",
            "institution": "CNRS - Laboratoire d’Informatique, Signaux et Systèmes de Sophia-Antipolis",
            "country": "France"
        },
        {
            "name": "Ruijie Wang",
            "institution": "University of Zurich",
            "country": "Switzerland"
        },
        {
            "name": "Shenghui Wang",
            "institution": "University of Twente",
            "country": "Netherlands"
        },
        {
            "name": "Xiaxia Wang",
            "institution": "University of Oxford",
            "country": "UK"
        },
        {
            "name": "Simon Werner",
            "institution": "Trier University",
            "country": "Germany"
        },
        {
            "name": "Xander Wilcke",
            "institution": "Vrije Universiteit Amsterdam",
            "country": "Netherlands"
        },
        {
            "name": "Josiane Xavier Parreira",
            "institution": "Siemens AG Österreich",
            "country": "Austria"
        },
        {
            "name": "Fouad Zablith",
            "institution": "American University of Beirut",
            "country": "Lebanon"
        },
        {
            "name": "Joseph Zalewski",
            "institution": "Kansas State University",
            "country": "USA"
        },
        {
            "name": "Antoine Zimmermann",
            "institution": "Ecole des Mines de Saint-Etienne",
            "country": "France"
        },
        {
            "name": "Remzi Çelebi",
            "institution": "Maastricht University",
            "country": "Netherlands"
        }
    ],
    "Resources Track Senior Program Committee": [
        {
            "name": "Philippe Cudre-Mauroux",
            "institution": "U. of Fribourg",
            "country": "Switzerland"
        },
        {
            "name": "Michel Dumontier",
            "institution": "Maastricht University",
            "country": "Netherlands"
        },
        {
            "name": "Anna Fensel",
            "institution": "Wageningen University & Research",
            "country": "Netherlands"
        },
        {
            "name": "Aidan Hogan",
            "institution": "Universidad de Chile",
            "country": "Chile"
        },
        {
            "name": "Milan Markovic",
            "institution": "University of Aberdeen",
            "country": "UK"
        },
        {
            "name": "Lionel Medini",
            "institution": "Universite Claude Bernard Lyon1",
            "country": "France"
        },
        {
            "name": "Nandana Mihindukulasooriya",
            "institution": "IBM Research",
            "country": "USA"
        },
        {
            "name": "Pascal Molli",
            "institution": "University of Nantes - LS2N",
            "country": "France"
        },
        {
            "name": "Tong Ruan",
            "institution": "ECUST",
            "country": "China"
        },
        {
            "name": "Marta Sabou",
            "institution": "Vienna University of Economics and Business",
            "country": "Austria"
        },
        {
            "name": "Ruben Taelman",
            "institution": "Ghent University – imec",
            "country": "Belgium"
        },
        {
            "name": "Maria-Esther Vidal",
            "institution": "Leibniz University Hannover",
            "country": "Germany"
        },
        {
            "name": "Xiaowang Zhang",
            "institution": "Tianjin University",
            "country": "China"
        }
    ],
    "Resources Track Program Committee": [
        {
            "name": "Daniel Adam",
            "institution": "Prague University of Economics and Business",
            "country": "Czechia"
        },
        {
            "name": "Mark Adamik",
            "institution": "Vrije Universiteit Amsterdam",
            "country": "Netherlands"
        },
        {
            "name": "Mehdi Akbari Gurabi",
            "institution": "Fraunhofer Institute for Applied Information Technology FIT",
            "country": "Germany"
        },
        {
            "name": "Vladimir Alexiev",
            "institution": "Graphwise.ai",
            "country": "Bulgaria"
        },
        {
            "name": "Jorge Alvarez Fidalgo",
            "institution": "Universidad de Oviedo",
            "country": "Spain"
        },
        {
            "name": "Vito Walter Anelli",
            "institution": "Politecnico di Bari",
            "country": "Italy"
        },
        {
            "name": "Simone Angioni",
            "institution": "CNR-ISTI",
            "country": "Italy"
        },
        {
            "name": "Gianluca Apriceno",
            "institution": "Fondazione Bruno Kessler",
            "country": "Italy"
        },
        {
            "name": "Ghislain Atemezing",
            "institution": "European Union Agency for Railways",
            "country": "France"
        },
        {
            "name": "Miriam Baglioni",
            "institution": "CNR-ISTI",
            "country": "Italy"
        },
        {
            "name": "Sahil Bansal",
            "institution": "SAP",
            "country": "USA"
        },
        {
            "name": "Roberto Barile",
            "institution": "University of Bari Aldo Moro",
            "country": "Italy"
        },
        {
            "name": "Hannah Bast",
            "institution": "University of Freiburg",
            "country": "Germany"
        },
        {
            "name": "Hossein Beigi Nasrabadi",
            "institution": "FIZ Karlsruhe, Leibniz Institute for Information Infrastructure",
            "country": "Germany"
        },
        {
            "name": "German Alejandro Braun",
            "institution": "Universidad Nacional del Comahue",
            "country": "Argentina"
        },
        {
            "name": "Gregoire Burel",
            "institution": "The Open University",
            "country": "UK"
        },
        {
            "name": "Diego Calvanese",
            "institution": "Free University of Bozen-Bolzano",
            "country": "Italy"
        },
        {
            "name": "Miguel Ceriani",
            "institution": "Institute for Cognitive Sciences and Technologies",
            "country": "Italy"
        },
        {
            "name": "Pierre-Antoine Champin",
            "institution": "W3C, and Inria",
            "country": "France"
        },
        {
            "name": "David Chaves-Fraga",
            "institution": "Universidade de Santiago de Compostela",
            "country": "Spain"
        },
        {
            "name": "Gong Cheng",
            "institution": "Nanjing University",
            "country": "China"
        },
        {
            "name": "Fiorela Ciroku",
            "institution": "Institute of Cognitive Sciences and Technologies",
            "country": "Italy"
        },
        {
            "name": "Diego Conde-Herreros",
            "institution": "Universidad Politecnica de Madrid",
            "country": "Spain"
        },
        {
            "name": "Oscar Corcho",
            "institution": "Universidad Politecnica de Madrid",
            "country": "Spain"
        },
        {
            "name": "David Corsar",
            "institution": "Robert Gordon University",
            "country": "UK"
        },
        {
            "name": "Marco Cremaschi",
            "institution": "University of Milano-Bicocca",
            "country": "Italy"
        },
        {
            "name": "Claudia d'Amato",
            "institution": "University of Bari",
            "country": "Italy"
        },
        {
            "name": "Jennifer D'Souza",
            "institution": "TIB Leibniz Information Centre for Science and Technology",
            "country": "Germany"
        },
        {
            "name": "Jerome David",
            "institution": "Universite Grenoble Alpes - INRIA",
            "country": "France"
        },
        {
            "name": "Stefano De Giorgis",
            "institution": "Vrije Universiteit Amsterdam",
            "country": "Netherlands"
        },
        {
            "name": "Christophe Debruyne",
            "institution": "Universite de Liege",
            "country": "Belgium"
        },
        {
            "name": "Stefan Decker",
            "institution": "RWTH Aachen University",
            "country": "Germany"
        },
        {
            "name": "Pathirage Deelaka",
            "institution": "Rensselaer Polytechnic Institute",
            "country": "USA"
        },
        {
            "name": "Caglar Demir",
            "institution": "Paderborn University",
            "country": "Germany"
        },
        {
            "name": "Rohit Arunrao Deshmukh",
            "institution": "Fraunhofer Institute for Applied Information Technology FIT",
            "country": "Germany"
        },
        {
            "name": "Davide Di Pierro",
            "institution": "Universite de Montpellier",
            "country": "France"
        },
        {
            "name": "Dimitar Dimitrov",
            "institution": "GESIS Leibniz Institute for the Social Sciences",
            "country": "Germany"
        },
        {
            "name": "Daniil Dobriy",
            "institution": "Vienna University of Economics and Business",
            "country": "Austria"
        },
        {
            "name": "Milan Dojchinovski",
            "institution": "Czech Technical University in Prague",
            "country": "Czechia"
        },
        {
            "name": "Mauro Dragoni",
            "institution": "Fondazione Bruno Kessler",
            "country": "Italy"
        },
        {
            "name": "Fajar J. Ekaputra",
            "institution": "Vienna University of Economics and Business",
            "country": "Austria"
        },
        {
            "name": "Beatriz Esteves",
            "institution": "Ghent University",
            "country": "Belgium"
        },
        {
            "name": "Sebastian Ferrada",
            "institution": "Universidad de Chile",
            "country": "Chile"
        },
        {
            "name": "Nicolas Ferranti",
            "institution": "Vienna University of Economics and Business",
            "country": "Austria"
        },
        {
            "name": "Rosa Filgueira",
            "institution": "University of Edinburgh (EPCC)",
            "country": "UK"
        },
        {
            "name": "Pablo Fillottrani",
            "institution": "Universidad Nacional del Sur",
            "country": "Argentina"
        },
        {
            "name": "Kathrin Fullenbach",
            "institution": "eccenca",
            "country": "Netherlands"
        },
        {
            "name": "Susmita Gangopadhyay",
            "institution": "GESIS Leibniz Institute for the Social Sciences",
            "country": "Germany"
        },
        {
            "name": "Katerina Gkirtzou",
            "institution": "ILSP - Athena Research Center",
            "country": "Greece"
        },
        {
            "name": "Sergio Alejandro Gomez",
            "institution": "Universidad Nacional del Sur",
            "country": "Argentina"
        },
        {
            "name": "Jorge Gracia",
            "institution": "University of Zaragoza",
            "country": "Spain"
        },
        {
            "name": "Arianna Graciotti",
            "institution": "University of Bologna",
            "country": "Italy"
        },
        {
            "name": "Christophe Guerret",
            "institution": "Accenture Labs",
            "country": "Ireland"
        },
        {
            "name": "Xin Fan Guo",
            "institution": "King's College London",
            "country": "UK"
        },
        {
            "name": "Peter Haase",
            "institution": "metaphacts",
            "country": "Germany"
        },
        {
            "name": "Linyi Han",
            "institution": "Tianjin University",
            "country": "China"
        },
        {
            "name": "Fatma-Zohra Hannou",
            "institution": "EDF Recherche et Developpement",
            "country": "France"
        },
        {
            "name": "Fabian Hoppe",
            "institution": "Vrije Universiteit Amsterdam",
            "country": "Netherlands"
        },
        {
            "name": "Ana Iglesias-Molina",
            "institution": "Universidad Politecnica de Madrid",
            "country": "Spain"
        },
        {
            "name": "Eleni Ilkou",
            "institution": "TIB Leibniz Information Centre for Science and Technology University Library",
            "country": "Germany"
        },
        {
            "name": "Theofilos Ioannidis",
            "institution": "National and Kapodistrian University of Athens",
            "country": "Greece"
        },
        {
            "name": "Antoine Isaac",
            "institution": "Europeana and Vrije Universiteit Amsterdam",
            "country": "Netherlands"
        },
        {
            "name": "Nitisha Jain",
            "institution": "King's College London",
            "country": "UK"
        },
        {
            "name": "Clement Jonquet",
            "institution": "MISTEA (INRAE) and LIRMM (University of Montpellier)",
            "country": "France"
        },
        {
            "name": "Milos Jovanovik",
            "institution": "Vienna University of Technology",
            "country": "Austria"
        },
        {
            "name": "Eduard Kamburjan",
            "institution": "IT University of Copenhagen",
            "country": "Denmark"
        },
        {
            "name": "Yavuz Selim Kartal",
            "institution": "GESIS Leibniz Institute for the Social Sciences",
            "country": "Germany"
        },
        {
            "name": "Evgeny Kharlamov",
            "institution": "Bosch Centre for AI, Germany, and University of Oslo",
            "country": "Norway"
        },
        {
            "name": "Christian Kindermann",
            "institution": "Stanford University",
            "country": "USA"
        },
        {
            "name": "Tomas Kliegr",
            "institution": "Prague University of Economics and Business",
            "country": "Czechia"
        },
        {
            "name": "Jakub Klimek",
            "institution": "Charles University",
            "country": "Czechia"
        },
        {
            "name": "Manolis Koubarakis",
            "institution": "National and Kapodistrian University of Athens",
            "country": "Greece"
        },
        {
            "name": "Kabul Kurniawan",
            "institution": "Universitas Gadjah Mada",
            "country": "Indonesia"
        },
        {
            "name": "Jose Emilio Labra Gayo",
            "institution": "Universidad de Oviedo",
            "country": "Spain"
        },
        {
            "name": "Christoph Lange",
            "institution": "Fraunhofer Institute for Applied Information Technology FIT, and RWTH Aachen University",
            "country": "Germany"
        },
        {
            "name": "Nicolas Lazzari",
            "institution": "University of Bologna",
            "country": "Italy"
        },
        {
            "name": "Xiaoze Liu",
            "institution": "Purdue University",
            "country": "USA"
        },
        {
            "name": "Zola Mahlaza",
            "institution": "University of Cape Town",
            "country": "South Africa"
        },
        {
            "name": "Andrea Mannocci",
            "institution": "CNR-ISTI",
            "country": "Italy"
        },
        {
            "name": "Patricia Martín-Chozas",
            "institution": "Universidad Politécnica de Madrid",
            "country": "Spain"
        },
        {
            "name": "Antonello Meloni",
            "institution": "University of Cagliari",
            "country": "Italy"
        },
        {
            "name": "Eduardo Mena",
            "institution": "University of Zaragoza",
            "country": "Spain"
        },
        {
            "name": "Albert Meroño-Peñuela",
            "institution": "King’s College London",
            "country": "UK"
        },
        {
            "name": "Cedric Möller",
            "institution": "University of Hamburg",
            "country": "Germany"
        },
        {
            "name": "Alba Catalina Morales Tirado",
            "institution": "The Open University",
            "country": "UK"
        },
        {
            "name": "Alessandro Mosca",
            "institution": "Institute for Cognitive Sciences and Technologies",
            "country": "Italy"
        },
        {
            "name": "Daham Mustafa",
            "institution": "Fraunhofer Institute for Applied Information Technology FIT",
            "country": "Germany"
        },
        {
            "name": "Lina Nachabe",
            "institution": "LIMOS, Ecole des Mines de Saint-Etienne",
            "country": "France"
        },
        {
            "name": "Iman Naja",
            "institution": "The Open University",
            "country": "UK"
        },
        {
            "name": "Ebrahim Norouzi",
            "institution": "FIZ Karlsruhe, Leibniz-Institut für Informationsinfrastruktur",
            "country": "Germany"
        },
        {
            "name": "Louis-Félix Nothias",
            "institution": "Université Côte d’Azur, and Institut Interdisciplinaire d’Intelligence Artificielle (3iA) Côte d’Azur, Sophia-Antipolis",
            "country": "France"
        },
        {
            "name": "Beatriz Olarte-Martinez",
            "institution": "Politecnico di Milano",
            "country": "Italy"
        },
        {
            "name": "Sarah Rebecca Ondraszek",
            "institution": "FIZ Karlsruhe, Leibniz Institute for Information Infrastructure",
            "country": "Germany"
        },
        {
            "name": "Axel Polleres",
            "institution": "Vienna University of Economics and Business",
            "country": "Austria"
        },
        {
            "name": "María Poveda-Villalón",
            "institution": "Universidad Politécnica de Madrid",
            "country": "Spain"
        },
        {
            "name": "Martino Mare Lakota Pulici",
            "institution": "Bosch Centre for AI",
            "country": "Germany"
        },
        {
            "name": "Georg Rehm",
            "institution": "DFKI",
            "country": "Germany"
        },
        {
            "name": "Maria del Mar Roldan-Garcia",
            "institution": "Universidad de Malaga",
            "country": "Spain"
        },
        {
            "name": "Harald Sack",
            "institution": "FIZ Karlsruhe, Leibniz Institute for Information Infrastructure, and KIT Karlsruhe",
            "country": "Germany"
        },
        {
            "name": "Henrique Santos",
            "institution": "Rensselaer Polytechnic Institute",
            "country": "USA"
        },
        {
            "name": "Sonja Schimmler",
            "institution": "Fraunhofer FOKUS, Technical University Berlin",
            "country": "Germany"
        },
        {
            "name": "Umutcan Serles",
            "institution": "Onlim GmbH",
            "country": "Austria"
        },
        {
            "name": "Mohamed Ahmed Sherif",
            "institution": "Paderborn University",
            "country": "Germany"
        },
        {
            "name": "Meilin Shi",
            "institution": "University of Vienna",
            "country": "Austria"
        },
        {
            "name": "Thibaut Soulard",
            "institution": "Paris-Saclay University",
            "country": "France"
        },
        {
            "name": "Blerina Spahiu",
            "institution": "Università degli Studi di Milano Bicocca",
            "country": "Italy"
        },
        {
            "name": "George Stamoulis",
            "institution": "National and Kapodistrian University of Athens",
            "country": "Greece"
        },
        {
            "name": "Armando Stellato",
            "institution": "University of Rome Tor Vergata",
            "country": "Italy"
        },
        {
            "name": "Vojtěch Sv´atek",
            "institution": "Prague University of Economics and Business",
            "country": "Czechia"
        },
        {
            "name": "Mary Ann Tan",
            "institution": "FIZ Karlsruhe, Leibniz Institute for Information Infrastructure",
            "country": "Germany"
        },
        {
            "name": "Aisling Third",
            "institution": "The Open University",
            "country": "UK"
        },
        {
            "name": "Tabea Tietz",
            "institution": "FIZ Karlsruhe, Leibniz Institute for Information Infrastructure",
            "country": "Germany"
        },
        {
            "name": "Konstantin Todorov",
            "institution": "LIRMM / University of Montpellier",
            "country": "France"
        },
        {
            "name": "Dimitar Trajanov",
            "institution": "ss. Cyril and Methodius University - Skopje",
            "country": "North Macedonia"
        },
        {
            "name": "Cassia Trojahn",
            "institution": "Université Grenoble Alpes - INRIA",
            "country": "France"
        },
        {
            "name": "Mahsa Vafaie",
            "institution": "FIZ Karlsruhe, Leibniz Institute for Information Infrastructure, and KIT Karlsruhe",
            "country": "Germany"
        },
        {
            "name": "Joerg Waitelonis",
            "institution": "yovisto GmbH",
            "country": "Germany"
        },
        {
            "name": "Zhichun Wang",
            "institution": "Beijing Normal University",
            "country": "China"
        },
        {
            "name": "Meng Wang",
            "institution": "Tongji University",
            "country": "China"
        },
        {
            "name": "Jesse Wright",
            "institution": "University of Oxford",
            "country": "UK"
        },
        {
            "name": "Tianxing Wu",
            "institution": "Southeast University",
            "country": "China"
        },
        {
            "name": "Beyza Yaman",
            "institution": "ADAPT Centre - Trinity College Dublin",
            "country": "Ireland"
        },
        {
            "name": "Hamada Zahera",
            "institution": "Paderborn University",
            "country": "Germany"
        },
        {
            "name": "Ondřej Zamazal",
            "institution": "Prague University of Economics and Business",
            "country": "Czechia"
        },
        {
            "name": "Sai Zhang",
            "institution": "Tianjin University",
            "country": "China"
        },
        {
            "name": "Ningyu Zhang",
            "institution": "Zhejiang University",
            "country": "China"
        },
        {
            "name": "Rui Zhao",
            "institution": "University of Oxford",
            "country": "UK"
        },
        {
            "name": "Zhuoxun Zheng",
            "institution": "Bosch Centre for AI",
            "country": "Germany"
        }
    ],
    "In-Use Track Program Committee": [
        {
            "name": "Luigi Asprino",
            "institution": "CNR - Institute of Cognitive Sciences and Technologies",
            "country": "Italy"
        },
        {
            "name": "Nathalie Aussenac-Gilles",
            "institution": "IRIT CNRS, University of Toulouse",
            "country": "France"
        },
        {
            "name": "Sahil Bansal",
            "institution": "SAP",
            "country": "USA"
        },
        {
            "name": "Oliver Bensch",
            "institution": "German Aerospace Center (DLR)",
            "country": "Germany"
        },
        {
            "name": "Carlos Buil Aranda",
            "institution": "Philip Morris International",
            "country": "Spain"
        },
        {
            "name": "Jean-Paul Calbimonte",
            "institution": "University of Applied Sciences and Arts Western Switzerland HES-SO",
            "country": "Switzerland"
        },
        {
            "name": "Miguel Ceriani",
            "institution": "University of Bari",
            "country": "Italy"
        },
        {
            "name": "Fiorela Ciroku",
            "institution": "CNR - Institute of Cognitive Sciences and Technologies",
            "country": "Italy"
        },
        {
            "name": "Damien Graux",
            "institution": "Huawei Technologies R&D (UK) Ltd.",
            "country": "UK"
        },
        {
            "name": "Peter Haase",
            "institution": "metaphacts",
            "country": "Germany"
        },
        {
            "name": "Lars Heling",
            "institution": "SAP SE",
            "country": "Germany"
        },
        {
            "name": "Mayank Kejriwal",
            "institution": "University of Southern California",
            "country": "USA"
        },
        {
            "name": "Craig Knoblock",
            "institution": "USC Information Sciences Institute",
            "country": "USA"
        },
        {
            "name": "Christoph Lange",
            "institution": "Fraunhofer Institute for Applied Information Technology FIT and RWTH Aachen University",
            "country": "Germany"
        },
        {
            "name": "Anna Sofia Lippolis",
            "institution": "CNR - Institute of Cognitive Sciences and Technologies",
            "country": "Italy"
        },
        {
            "name": "C. Fabio Longo",
            "institution": "CNR - Institute of Cognitive Sciences and Technologies",
            "country": "Italy"
        },
        {
            "name": "Michael Luggen",
            "institution": "University of Fribourg",
            "country": "Switzerland"
        },
        {
            "name": "Ioanna Lytra",
            "institution": "Graphwise",
            "country": "Austria"
        },
        {
            "name": "Beatrice Markhoff",
            "institution": "Universit´e de Tours, UMR 7324 CITERES",
            "country": "France"
        },
        {
            "name": "Antonello Meloni",
            "institution": "University of Cagliary",
            "country": "Italy"
        },
        {
            "name": "Johannes M¨akelburg",
            "institution": "Technical University of Munich",
            "country": "Germany"
        },
        {
            "name": "D O’Sullivan",
            "institution": "Trinity College Dublin",
            "country": "Ireland"
        },
        {
            "name": "Francesco Poggi",
            "institution": "CNR - Institute of Cognitive Sciences and Technologies",
            "country": "Italy"
        },
        {
            "name": "Mariano Rico",
            "institution": "Universidad Polit´ecnica de Madrid",
            "country": "Spain"
        },
        {
            "name": "Tong Ruan",
            "institution": "ECUST",
            "country": "China"
        },
        {
            "name": "Edna Ruckhaus",
            "institution": "Universidad Polit´ecnica de Madrid",
            "country": "Spain"
        },
        {
            "name": "Alessandro Russo",
            "institution": "CNR - Institute of Cognitive Sciences and Technologies",
            "country": "Italy"
        },
        {
            "name": "Mohamad Javad Saeedizade",
            "institution": "Linköping University",
            "country": "Sweden"
        },
        {
            "name": "David Maria Schmidt",
            "institution": "Bielefeld University",
            "country": "Germany"
        },
        {
            "name": "Tim Schwabe",
            "institution": "Technical University of Munich",
            "country": "Germany"
        }
    ],
    "In-Use Track Additional Reviewers": [
        {
            "name": "Alexander Graß",
            "institution": "RWTH Aachen University",
            "country": "Germany"
        },
        {
            "name": "Ashutosh Hathidara",
            "institution": "SAP",
            "country": "USA"
        },
        {
            "name": "Fandel Lin",
            "institution": "University of Southern California",
            "country": "USA"
        },
        {
            "name": "Ramit Pahwa",
            "institution": "Rivian and VW Group Technologies",
            "country": "USA"
        },
        {
            "name": "Johannes Theissen-Lipp",
            "institution": "RWTH Aachen University",
            "country": "Germany"
        },
        {
            "name": "Binh Vu",
            "institution": "University of Southern California",
            "country": "USA"
        }
    ],
    "Poster & Demo Track Committee": [
        {
            "name": "Elvira Amador-Domínguez",
            "institution": "Universidad Politécnica de Madrid",
            "country": ""
        },
        {
            "name": "Hiba Arnaout",
            "institution": "TU Darmstadt",
            "country": ""
        },
        {
            "name": "Dörthe Arndt",
            "institution": "TU Dresden",
            "country": ""
        },
        {
            "name": "Martin Bauer",
            "institution": "NEC Laboratories Europe",
            "country": ""
        },
        {
            "name": "Carlos Bobed",
            "institution": "University of Zaragoza, Spain",
            "country": ""
        },
        {
            "name": "Pieter Bonte",
            "institution": "KU Leuven",
            "country": ""
        },
        {
            "name": "Janez Brank",
            "institution": "Jožef Stefan Institute",
            "country": ""
        },
        {
            "name": "Jean-Paul Calbimonte",
            "institution": "University of Applied Sciences and Arts Western Switzerland HES-SO",
            "country": ""
        },
        {
            "name": "Jieying Chen",
            "institution": "Vrije Universiteit Amsterdam",
            "country": ""
        },
        {
            "name": "Ioannis Chrysakis",
            "institution": "FORTH-ICS (Greece) and Dept. of Electronics and Information Systems, Ghent University - IDLab – imec (Belgium)",
            "country": ""
        },
        {
            "name": "Yashrajsinh Chudasama",
            "institution": "Leibniz University Hannover",
            "country": ""
        },
        {
            "name": "Oscar Corcho",
            "institution": "Universidad Politécnica de Madrid",
            "country": ""
        },
        {
            "name": "Enrico Daga",
            "institution": "The Open University",
            "country": ""
        },
        {
            "name": "Stefano De Giorgis",
            "institution": "Vrije Universiteit Amsterdam ",
            "country": ""
        },
        {
            "name": "Christophe Debruyne",
            "institution": "Université de Liège",
            "country": ""
        },
        {
            "name": "Vasilis Efthymiou",
            "institution": "Harokopio University of Athens",
            "country": ""
        },
        {
            "name": "Shusaku Egami",
            "institution": "National Institute of Advanced Industrial Science and Technology",
            "country": ""
        },
        {
            "name": "Holly Ferguson",
            "institution": "Personal Research",
            "country": ""
        },
        {
            "name": "Sebastián Ferrada",
            "institution": "Universidad de Chile",
            "country": ""
        },
        {
            "name": "Giorgos Flouris",
            "institution": "ICS-FORTH",
            "country": ""
        },
        {
            "name": "Kathleen Fontaine",
            "institution": "Rensselaer Polytechnic Institute",
            "country": ""
        },
        {
            "name": "Naoki Fukuta",
            "institution": "Shizuoka University",
            "country": ""
        },
        {
            "name": "Sandra Geisler",
            "institution": "Data Stream Management and Analysis, RWTH Aachen University",
            "country": ""
        },
        {
            "name": "Pouya Ghiasnezhad Omran",
            "institution": "Australian National University",
            "country": ""
        },
        {
            "name": "Martin Giese",
            "institution": "University of Oslo",
            "country": ""
        },
        {
            "name": "Simon Gottschalk",
            "institution": "Leibniz Universität Hannover, L3S Research Center",
            "country": ""
        },
        {
            "name": "Damien Graux",
            "institution": "EcoVadis",
            "country": ""
        },
        {
            "name": "Claudio Gutierrez",
            "institution": "Universidad de Chile",
            "country": ""
        },
        {
            "name": "Peter Haase",
            "institution": "metaphacts",
            "country": ""
        },
        {
            "name": "Mounira Harzallah",
            "institution": "LS2N, University of Nantes, France",
            "country": ""
        },
        {
            "name": "Daniel Hernández",
            "institution": "University of Stuttgart",
            "country": ""
        },
        {
            "name": "Ryohei Hisano",
            "institution": "ETH Zurich",
            "country": ""
        },
        {
            "name": "Wei Hu",
            "institution": "Nanjing University",
            "country": ""
        },
        {
            "name": "Luis-Daniel Ibáñez",
            "institution": "University of Southampton",
            "country": ""
        },
        {
            "name": "Timotheus Kampik",
            "institution": "SAP, Umeå University",
            "country": ""
        },
        {
            "name": "Takahiro Kawamura",
            "institution": "The University of Tokyo",
            "country": ""
        },
        {
            "name": "Mayank Kejriwal",
            "institution": "University of Southern California",
            "country": ""
        },
        {
            "name": "Mayank Kharbanda",
            "institution": "Indraprastha Institute of Information Technology Delhi",
            "country": ""
        },
        {
            "name": "Craig Knoblock",
            "institution": "USC Information Sciences Institute",
            "country": ""
        },
        {
            "name": "Haridimos Kondylakis",
            "institution": "Institute of Computer Science, FORTH",
            "country": ""
        },
        {
            "name": "Roman Kontchakov",
            "institution": "Birkbeck, University of London",
            "country": ""
        },
        {
            "name": "Manolis Koubarakis",
            "institution": "National and Kapodistrian University of Athens",
            "country": ""
        },
        {
            "name": "Sébastien Laborie",
            "institution": "LIUPPA - Université de Pau et des Pays de l'Adour",
            "country": ""
        },
        {
            "name": "Jose Emilio Labra Gayo",
            "institution": "Universidad de Oviedo",
            "country": ""
        },
        {
            "name": "Christoph Lange",
            "institution": "Fraunhofer Institute for Applied Information Technology FIT and RWTH Aachen University, Germany",
            "country": ""
        },
        {
            "name": "Davide Lanti",
            "institution": "Free University of Bozen-Bolzano",
            "country": ""
        },
        {
            "name": "Huanyu Li",
            "institution": "Linköping University, Sweden",
            "country": ""
        },
        {
            "name": "Daxin Liu",
            "institution": "Nanjing University",
            "country": ""
        },
        {
            "name": "Xiaoze Liu",
            "institution": "Purdue University",
            "country": ""
        },
        {
            "name": "Ioanna Lytra",
            "institution": "Semantic Web Company",
            "country": ""
        },
        {
            "name": "Jose L. Martinez-Rodriguez",
            "institution": "Autonomous University of Tamaulipas",
            "country": ""
        },
        {
            "name": "Margherita Martorana",
            "institution": "Vrije Universiteit Amsterdam",
            "country": ""
        },
        {
            "name": "Simon Mayer",
            "institution": "University of St.Gallen",
            "country": ""
        },
        {
            "name": "Marc Maynou",
            "institution": "Universitat Politècnica de Catalunya",
            "country": ""
        },
        {
            "name": "Albert Meroño-Peñuela",
            "institution": "King's College London",
            "country": ""
        },
        {
            "name": "Thomas Meyer",
            "institution": "University of Cape Town and CAIR",
            "country": ""
        },
        {
            "name": "Nandana Mihindukulasooriya",
            "institution": "IBM Research",
            "country": ""
        },
        {
            "name": "Seyedreza Mohseni",
            "institution": "Program Committee member",
            "country": ""
        },
        {
            "name": "Pascal Molli",
            "institution": "University of Nantes - LS2N",
            "country": ""
        },
        {
            "name": "Pierre Monnin",
            "institution": "Université Côte d'Azur, Inria, CNRS, I3S, Sophia Antipolis, France",
            "country": ""
        },
        {
            "name": "Ummara Mumtaz",
            "institution": "University of the Cumberlands",
            "country": ""
        },
        {
            "name": "Summaya Mumtaz",
            "institution": "University of Oslo",
            "country": ""
        },
        {
            "name": "Raghava Mutharaju",
            "institution": "IIIT-Delhi, India",
            "country": ""
        },
        {
            "name": "Muhammad Raza Naqvi",
            "institution": "Mines Saint-Etienne, Saint-Etienne, France",
            "country": ""
        },
        {
            "name": "Hien D. Nguyen",
            "institution": "University of Information Technology, VNU-HCM, Vietnam",
            "country": ""
        },
        {
            "name": "Sapan Pandya",
            "institution": "Independent Researcher, United States",
            "country": ""
        },
        {
            "name": "Peter Patel-Schneider",
            "institution": "NONE",
            "country": ""
        },
        {
            "name": "Evan Patton",
            "institution": "Massachusetts Institute of Technology",
            "country": ""
        },
        {
            "name": "Heiko Paulheim",
            "institution": "University of Mannheim",
            "country": ""
        },
        {
            "name": "Bernardo Pereira Nunes",
            "institution": "Australian National University",
            "country": ""
        },
        {
            "name": "Alina Petrova",
            "institution": "University of Oxford",
            "country": ""
        },
        {
            "name": "Gerard Pons",
            "institution": "Universitat Politècnica de Catalunya",
            "country": ""
        },
        {
            "name": "David Ratcliffe",
            "institution": "Microsoft",
            "country": ""
        },
        {
            "name": "Juan Manuel Rodriguez",
            "institution": "Aalborg University",
            "country": ""
        },
        {
            "name": "Philipp D. Rohde",
            "institution": "TIB Leibniz Information Centre for Science and Technology",
            "country": ""
        },
        {
            "name": "Edelweis Rohrer",
            "institution": "Facultad de Ingeniería - Universidad de la República, Uruguay",
            "country": ""
        },
        {
            "name": "Henry Rosales-Méndez",
            "institution": "University of Chile",
            "country": ""
        },
        {
            "name": "Jože M. Rožanec",
            "institution": "Jožef Stefan Institute / University of Twente",
            "country": ""
        },
        {
            "name": "Tomer Sagi",
            "institution": "Aalborg Universitet",
            "country": ""
        },
        {
            "name": "Emanuel Sallinger",
            "institution": "TU Wien",
            "country": ""
        },
        {
            "name": "Ralf Schenkel",
            "institution": "Trier University",
            "country": ""
        },
        {
            "name": "Qing Shi",
            "institution": "Nanjing University",
            "country": ""
        },
        {
            "name": "Sarah Binta Alam Shoilee",
            "institution": "Vrije Universiteit Amsterdam",
            "country": ""
        },
        {
            "name": "Hala Skaf-Molli",
            "institution": "University of Nantes - LS2N",
            "country": ""
        },
        {
            "name": "Martin G Skjæveland",
            "institution": "University of Oslo",
            "country": ""
        },
        {
            "name": "Ahmet Soylu",
            "institution": "OsloMet - Oslo Metropolitan University",
            "country": ""
        },
        {
            "name": "Lise Stork",
            "institution": "University of Amsterdam",
            "country": ""
        },
        {
            "name": "Chang Sun",
            "institution": "Institute of Data Science, Faculty of Science and Engineering, Maastricht University",
            "country": ""
        },
        {
            "name": "Danai Symeonidou",
            "institution": "INRAE, University of Montpellier",
            "country": ""
        },
        {
            "name": "Steffen Thoma",
            "institution": "FZI Research Center for Information Technology",
            "country": ""
        },
        {
            "name": "Ilaria Tiddi",
            "institution": "Vrije Universiteit Amsterdam",
            "country": ""
        },
        {
            "name": "Dominik Tomaszuk",
            "institution": "University of Bialystok",
            "country": ""
        },
        {
            "name": "Cassia Trojahn",
            "institution": "Univ. Grenoble Alpes, Inria, CNRS, Grenoble INP, France",
            "country": ""
        },
        {
            "name": "Takanori Ugai",
            "institution": "Fujitsu Limited",
            "country": ""
        },
        {
            "name": "Xiaxia Wang",
            "institution": "University of Oxford",
            "country": ""
        },
        {
            "name": "Ruijie Wang",
            "institution": "SIB Swiss Institute of Bioinformatics, University of Zurich",
            "country": ""
        },
        {
            "name": "Shuai Wang",
            "institution": "Vrije University Amsterdam",
            "country": ""
        },
        {
            "name": "Xander Wilcke",
            "institution": "Vrije Universiteit Amsterdam",
            "country": ""
        },
        {
            "name": "Tongtong Wu",
            "institution": "Monash University",
            "country": ""
        },
        {
            "name": "Tianxing Wu",
            "institution": "Southeast University",
            "country": ""
        },
        {
            "name": "Ran Yu",
            "institution": "GESIS-Leibniz Institute for the Social Sciences",
            "country": ""
        },
        {
            "name": "Fouad Zablith",
            "institution": "American University of Beirut",
            "country": ""
        },
        {
            "name": "Veruska Zamborlini",
            "institution": "KNAW Humanities Cluster, Netherlands & Federal University of Espirito Santo, Brazil",
            "country": ""
        },
        {
            "name": "Ningyu Zhang",
            "institution": "Zhejiang University",
            "country": ""
        }
    ],
    "Industry Track Program Committee": [
        {
            "name": "David     Chaves-Fraga",
            "institution": "Universidad de Santiago de Compostela",
            "country": "Spain"
        },
        {
            "name": "Federico D'Asaro",
            "institution": "LINKS Foundation",
            "country": "Italy"
        },
        {
            "name": "Ronald Denaux",
            "institution": "Amazon",
            "country": "Spain"
        },
        {
            "name": "Peter Haase",
            "institution": "metaphacts",
            "country": "Germany"
        },
        {
            "name": "Nico  Lavarini",
            "institution": "Expert.ai",
            "country": "Italy"
        },
        {
            "name": "Suvodeep Mazumdar",
            "institution": "University of Sheffield",
            "country": "UK"
        },
        {
            "name": "Nandana Mihindukulasooriya",
            "institution": "IBM Research, US",
            "country": "United States"
        },
        {
            "name": "Natasha Mulligan",
            "institution": "IBM Research Europe",
            "country": "Ireland"
        },
        {
            "name": "Paco Nathan",
            "institution": "Senzing",
            "country": "United States"
        },
        {
            "name": "Lydia Pintscher",
            "institution": "Wikimedia Deutschland",
            "country": "Germany"
        },
        {
            "name": "Juan Sequeda",
            "institution": "ServiceNow",
            "country": "United States"
        },
        {
            "name": "Basel Shbita",
            "institution": "IBM Research",
            "country": "United States"
        },
        {
            "name": "Josiane Xavier-Parreira",
            "institution": "Siemens AG Österreich",
            "country": "Austria"
        },
        {
            "name": "Fouad Zablith",
            "institution": "American University of Beirut",
            "country": "Lebanon"
        }
    ]
};
export default program_commitee_list;